import type { ReactNode } from "react";
import { PrecoDePor } from "./Promocao";

/**
 * Um plano a venda na area do cliente (15/10): o nome, o preco em destaque, uma ou duas linhas de apoio (o adicional do
 * Profit Pro, o dolar anunciado, como paga) e o botao que leva pro checkout. `rotulo` vai em cima do nome ("Seu
 * ultimo plano"); `destaque` marca o cartao com a cor da marca, pro "comprar de novo" vir na frente dos outros.
 * Nao sabe a marca nem a moeda: o preco chega pronto. Com promocao (spec 067), `selo` (o `SeloDaPromocao`) vai em cima
 * do nome e `precoDe` (o cheio) faz o preco virar "de / por", com o `preco` sendo o promocional.
 */
export function CartaoDeOferta({ nome, preco, precoDe, selo, apoio = [], rotulo, destaque, acao }: { nome: string; preco: ReactNode; precoDe?: ReactNode; selo?: ReactNode; apoio?: ReactNode[]; rotulo?: ReactNode; destaque?: boolean; acao: ReactNode }) {
  return (
    <article className={`mtc-cartao mtc-oferta${destaque ? " mtc-oferta--destaque" : ""}`} aria-label={nome}>
      {rotulo && <span className="mtc-rotulo mtc-oferta__rotulo">{rotulo}</span>}
      {selo && <div className="mtc-oferta__selo">{selo}</div>}
      <h3 className="mtc-oferta__nome">{nome}</h3>
      <span className="mtc-oferta__preco">{precoDe ? <PrecoDePor de={precoDe} por={preco} alinhar="inicio" /> : <strong>{preco}</strong>}</span>
      {apoio.filter(Boolean).map((linha, i) => <span key={i} className="mtc-oferta__apoio">{linha}</span>)}
      <div className="mtc-oferta__acao">{acao}</div>
    </article>
  );
}
